//import React from "react";
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ValidSelect } from "beaktShared/helpers/validselect";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";


// @material-ui/icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import Assignment from "@material-ui/icons/Assignment";
import LoadingIcon from "@material-ui/icons/Cached";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Select from 'react-select';
import Autocomplete from '@material-ui/lab/Autocomplete';

// services
import { MaskCPF, MaskCel, MaskDecimal, MaskDecimalComNegativo } from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const useStyles = makeStyles(styles);

export default function GestaoClienteProntuarioForm({ addItem, item, handleView, loading, clienteId, prontuarioId }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const endPoint = 'prontuario/';
    const session = useContext(SessionContext);
    const { register, handleSubmit, setValue, errors } = useForm({ mode: "onChange" });
    const [showPesquisa, setShowPesquisa] = React.useState(true);

    const [dataCadastro, setDataCadastro] = React.useState('');
    const [usuarioNome, setUsuarioNome] = React.useState('');

    // Valores iniciais
    const intialValues = {
        prontuarioId: 0,
        idcliente: 0,
        cpfcliente: '',
        nomecliente: '',
        dataCadastro: '',
    };
    
    const [franquia, setFranquia] = React.useState("");

    useEffect(() => {
        UseGetApiSimple("Franquias/GetByEstabelecimento/" + session.estabelecimentoId).then((result) => {
            if (result.status == 200) {
                if (result.data.avaliacao == "" || result.data.avaliacao == null)
                    setFranquia("Nenhum");
                else {
                    setFranquia(result.data.avaliacao);
                    session.franquiaId = result.data.franquiaId;
                }
            }
        });
    }, []);
    
    useEffect(() => {
        sendScrollToTOP();

        const init = async () => {
            if (prontuarioId === 0) {
                setShowPesquisa(false);
                setValue('nomecliente', item.nomecliente);
                setValue('cpfcliente', item.cpfcliente);
                setValue('emailcliente', item.clienteEmail)
                setValue('celularcliente', item.clienteCelular);
                return;
            }
            else {
                setValue('prontuarioId', prontuarioId);
                setUsuarioNome(item.usuarioNome);
                setShowPesquisa(false);
                let endPointGet = endPoint + prontuarioId;
                UseGetApiSimple(endPointGet, 0).then(result => {
                    if (result.status == 200) {
                        console.log(result);
                        loadProntuario(result.data);
                    }
                });
            }
        }

        init();
    }, [item]);

    const loadProntuario = (value) => {
        setDataCadastro(value.dataCadastro);
        setValue('nomecliente', value.clienteNome);
        setValue('cpfcliente', value.clienteCPF);
        setValue('emailcliente', value.clienteEmail)
        setValue('celularcliente', value.clienteCelular);
        setValue('glicose', value.glicose?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('hemoglobinaGlicada', value.hemoglobinaGlicada?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('insulina', value.insulina?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('peptideoCalculo', value.peptideoCalculo?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('perfilLipidico', value.perfilLipidico?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('ureia', value.ureia?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('creatinina', value.creatinina?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('tgo', value.tgo?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('tgp', value.tgp?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('evolucaoDeVO2', value.evolucaoDeVO2?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('vitaminaD', value.vitaminaD?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('triglicerideos', value.triglicerideos?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('g6PD', value.g6PD?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('massaMagra', value.massaMagra?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('hdl', value.hdl?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('ldl', value.ldl?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('homaIR', value.homaIR?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('gorduraVisceral', value.gorduraVisceral?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValue('vO2Absoluto', value.vO2Absoluto?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    }

    // Pesquisa cliente - Da forma que foi alterado, essa consulta não será usada
    const [pesquisaPor, setPesquisaPor] = React.useState("NOME");
    const optionsPesquisaPor = [
        { value: 'NOME', label: 'Nome' },
        { value: 'EMAIL', label: 'E-Mail' },
        { value: 'CPF', label: 'CPF' },
    ];
    const handlePesquisaPorChange = (value) => {
        setValue("idcliente", '');
        setValue("nomecliente", '');
        setValue("cpfcliente", '');
        setValue("celularcliente", '');
        setValue("emailcliente", '');
        setPesquisaPor(value);
    }

    const [searchForName, setSearchForName] = React.useState([]);
    const handleNameChange = (e) => {
        if (e !== null) {
            const nameContains = e.target.value;
            if (((nameContains !== null && nameContains !== undefined)) && nameContains.length >= 5) {
                const endPointCliente = "clientes/clientebyNomebyEstabelecimento/" + nameContains + "/" + session.estabelecimentoId;
                UseGetApiSimple(endPointCliente, 0).then(result => {
                    setSearchForName(result.data);

                });

            } else {
                setSearchForName([]);
            }
        }
    }

    const [searchForCPFChange, setSearchForCPFChange] = React.useState([]);
    const handleCPFSeachChange = (e) => {
        if (e !== null) {
            const cpfContains = e.target.value;

            if (((cpfContains !== null && cpfContains !== undefined)) && cpfContains.length >= 5) {
                const endPointCliente = "clientes/clientebyContaisCpfEstabelecimento/" + cpfContains + "/" + session.estabelecimentoId;
                UseGetApiSimple(endPointCliente, 0).then(result => {
                    setSearchForCPFChange(result.data);
                });
            } else {
                setSearchForCPFChange([]);
            }
        }
    }

    const [searchForEmailChange, setSearchForEmailChange] = React.useState([]);
    const handleEmailSeachChange = (e) => {
        if (e !== null) {
            const emailContains = e.target.value;

            if (((emailContains !== null && emailContains !== undefined)) && emailContains.length >= 5) {
                const endPointCliente = "clientes/clientebyEmailbyEstabelecimento/" + emailContains + "/" + session.estabelecimentoId;
                UseGetApiSimple(endPointCliente, 0).then(result => {
                    setSearchForEmailChange(result.data);
                });
            } else {
                setSearchForEmailChange([]);
            }
        }
    }

    const validateResult = (value) => {
        if (value !== null) {
            setValue("idcliente", value.clienteId);
            setValue("nomecliente", value.nome);
            setValue("cpfcliente", value.cpf);
            setValue("emailcliente", value.email);
            setValue("celularcliente", value.celular);
        }
        else {
            setValue("idcliente", '');
            setValue("nomecliente", '');
            setValue("cpfcliente", '');
            setValue("celularcliente", '');
            setValue("emailcliente", '');
        }
    }

    const handleViewForm = () => {
        handleView(true);
    };

    const onSubmit = (data, e) => {
        e.preventDefault();

        var prontuario = {
            prontuarioId: parseInt(data.prontuarioId),
            usuarioCadastroId: session.id,
            estabelecimentoId: session.estabelecimentoId,
            clienteId: clienteId,
            creatinina: data.creatinina ? data.creatinina.includes(',') ? data.creatinina.replace(',', '.') : data.creatinina : '',
            evolucaoDeVO2: data.evolucaoDeVO2 ? data.evolucaoDeVO2.includes(',') ? data.evolucaoDeVO2.replace(',', '.') : data.evolucaoDeVO2 : '0.00',
            glicose: data.glicose ? data.glicose.includes(',') ? data.glicose.replace(',', '.') : data.glicose : '',
            hemoglobinaGlicada: data.hemoglobinaGlicada ? data.hemoglobinaGlicada.includes(',') ? data.hemoglobinaGlicada.replace(',', '.') : data.hemoglobinaGlicada : '',
            insulina: data.insulina ? data.insulina.includes(',') ? data.insulina.replace(',', '.') : data.insulina : '',
            peptideoCalculo: data.peptideoCalculo ? data.peptideoCalculo.includes(',') ? data.peptideoCalculo.replace(',', '.') : data.peptideoCalculo : '',
            perfilLipidico: data.perfilLipidico ? data.perfilLipidico.includes(',') ? data.perfilLipidico.replace(',', '.') : data.perfilLipidico : '0.00',
            tgo: data.tgo ? data.tgo.includes(',') ? data.tgo.replace(',', '.') : data.tgo : '',
            tgp: data.tgp ? data.tgp.includes(',') ? data.tgp.replace(',', '.') : data.tgp : '',
            ureia: data.ureia ? data.ureia.includes(',') ? data.ureia.replace(',', '.') : data.ureia : '',
            vitaminaD: data.vitaminaD ? data.vitaminaD.includes(',') ? data.vitaminaD.replace(',', '.') : data.vitaminaD : '',
            triglicerideos: data.triglicerideos ? data.triglicerideos.includes(',') ? data.triglicerideos.replace(',', '.') : data.triglicerideos : '',
            g6PD: data.g6PD ? data.g6PD.includes(',') ? data.g6PD.replace(',', '.') : data.g6PD : '',
            massaMagra: data.massaMagra ? data.massaMagra.includes(',') ? data.massaMagra.replace(',', '.') : data.massaMagra : '',
            hdl: data.hdl ? data.hdl.includes(',') ? data.hdl.replace(',', '.') : data.hdl : '',
            ldl: data.ldl ? data.ldl.includes(',') ? data.ldl.replace(',', '.') : data.ldl : '',
            homaIR: data.homaIR ? data.homaIR.includes(',') ? data.homaIR.replace(',', '.') : data.homaIR : '',
            gorduraVisceral: data.gorduraVisceral ? data.gorduraVisceral.includes(',') ? data.gorduraVisceral.replace(',', '.') : data.gorduraVisceral : '',
            vO2Absoluto: data.vO2Absoluto ? data.vO2Absoluto.includes(',') ? data.vO2Absoluto.replace(',', '.') : data.vO2Absoluto : ''
        }

        addItem(prontuario);
    };

    const sendScrollToTOP = () => {
        const container = document.querySelector('#divscroll');
        container.scrollTop = 0;
        container.behavior = 'smooth';
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <PermIdentity />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    {t('sidebar.medical_record')}
                                    <input className={classes.hidden} defaultValue={intialValues.prontuarioId} name="prontuarioId" ref={register} />
                                </h4>
                            </CardHeader>
                            <CardBody>

                                {showPesquisa &&
                                    <>
                                        <GridContainer>
                                            <input className={classes.hidden} defaultValue={intialValues.idcliente} name="idcliente" ref={register} />
                                            <GridItem xs={12} sm={3} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <label className={errors.situacaoItem ? "select__label select__label_error" : "select__label"}>
                                                        {
                                                            t('label.search_for')
                                                        }
                                                    </label>
                                                    <Select
                                                        classNamePrefix="select"
                                                        styles={ValidSelect(errors.pesquisaPor ? true : false)}
                                                        isSearchable={true}
                                                        name="Pesquisa por"
                                                        options={optionsPesquisaPor}
                                                        value={optionsPesquisaPor.filter(({ value }) => value === pesquisaPor)}
                                                        onChange={(option) => handlePesquisaPorChange(option.value !== null ? option.value : "Nome")}
                                                        placeholder="Nome"
                                                        ref={() => register({ name: "Pesquisa por" })}
                                                    />
                                                </FormControl>
                                            </GridItem>

                                            <GridItem xs={12} sm={9} md={9}>

                                                <FormControl fullWidth className={classes.formControl}>
                                                    {
                                                        pesquisaPor === "NOME" ?
                                                            <>
                                                                <label className={errors.situacaoItem ? "select__label select__label_error" : "select__label"}>
                                                                    {
                                                                        t('label.client_name')
                                                                    }
                                                                </label>
                                                                <Autocomplete
                                                                    name="searchByName"
                                                                    noOptionsText="Digite os primeiros 5 caracteres para iniciar a busca"
                                                                    options={searchForName}
                                                                    getOptionLabel={(option) => {
                                                                        return option.nome;
                                                                    }}
                                                                    getOptionValue={({ clienteId }) => clienteId}
                                                                    onChange={(event, value) => {
                                                                        validateResult(value);
                                                                    }}
                                                                    onInputChange={handleNameChange}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            variant="outlined"
                                                                        />
                                                                    )}
                                                                />
                                                            </>
                                                            :
                                                            pesquisaPor === "CPF" ?
                                                                <>
                                                                    <label className={errors.situacaoItem ? "select__label select__label_error" : "select__label"}>
                                                                        {
                                                                            t('label.client_cpf')
                                                                        }
                                                                    </label>
                                                                    <Autocomplete
                                                                        name="searchByCPF"
                                                                        noOptionsText="Digite os primeiros 5 caracteres para iniciar a busca (apenas números)"
                                                                        options={searchForCPFChange}
                                                                        getOptionLabel={(option) => {
                                                                            var rCpf = option.cpf.replace(/[.-]/g, '');
                                                                            return rCpf;
                                                                        }}
                                                                        getOptionValue={({ clienteId }) => clienteId}
                                                                        onChange={(event, value) => {
                                                                            validateResult(value);
                                                                        }}
                                                                        onInputChange={handleCPFSeachChange}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                variant="outlined"
                                                                            />
                                                                        )}
                                                                    />
                                                                </>
                                                                :
                                                                pesquisaPor === "EMAIL" ?
                                                                    <>
                                                                        <label className={errors.situacaoItem ? "select__label select__label_error" : "select__label"}>
                                                                            {
                                                                                t('label.client_email')
                                                                            }
                                                                        </label>
                                                                        <Autocomplete
                                                                            name="searchByEmail"
                                                                            noOptionsText="Digite os primeiros 5 caracteres para iniciar a busca"
                                                                            options={searchForEmailChange}
                                                                            getOptionLabel={(option) => {
                                                                                return option.email;
                                                                            }}
                                                                            getOptionValue={({ clienteId }) => clienteId}
                                                                            onChange={(event, value) => {
                                                                                validateResult(value);
                                                                            }}
                                                                            onInputChange={handleEmailSeachChange}
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params}
                                                                                    variant="outlined"
                                                                                />
                                                                            )}
                                                                        />
                                                                    </>
                                                                    :
                                                                    <></>
                                                    }

                                                </FormControl>
                                            </GridItem>
                                        </GridContainer>
                                        <hr className="lineGray" />
                                    </>
                                }

                                {prontuarioId !== 0 &&
                                    <>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <p>
                                                        <strong>{t('label.registered_in')}: </strong>
                                                        {dataCadastro ? new Date(dataCadastro).toLocaleDateString('pt-BR') : 'Data inválida'}
                                                    </p>
                                                    <p>
                                                        <strong>{t('label.registered_by')}: </strong>
                                                        {usuarioNome}
                                                    </p>
                                                </FormControl>
                                            </GridItem>
                                        </GridContainer>
                                        <hr className="lineGray" />
                                    </>
                                }

                                {showPesquisa &&
                                    <>
                                        <GridContainer>
                                            <GridItem xs={12} sm={3} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        label="CPF"
                                                        variant="outlined"
                                                        inputRef={register({ required: false })}
                                                        name="cpfcliente"
                                                        disabled={true}
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{
                                                            inputComponent: MaskCPF,
                                                        }}
                                                    />
                                                </FormControl>
                                            </GridItem>

                                            <GridItem xs={12} sm={9} md={9}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        label={t('label.client_name')}
                                                        variant="outlined"
                                                        inputRef={register({ required: false })}
                                                        name="nomecliente"
                                                        defaultValue={intialValues.nomecliente}
                                                        disabled={true}
                                                        InputLabelProps={{ shrink: true }}
                                                        inputProps={{ maxLength: 100 }}
                                                    />
                                                </FormControl>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={3} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        label="Celular"
                                                        variant="outlined"
                                                        inputRef={register({ required: false })}
                                                        name="celularcliente"
                                                        disabled={true}
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{ inputComponent: MaskCel }}
                                                    />
                                                </FormControl>
                                            </GridItem>

                                            <GridItem xs={12} sm={9} md={9}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        label={t('label.client_email')}
                                                        variant="outlined"
                                                        inputRef={register({ required: false })}
                                                        name="emailcliente"
                                                        defaultValue={intialValues.emailcliente}
                                                        disabled={true}
                                                        InputLabelProps={{ shrink: true }}
                                                        inputProps={{ maxLength: 100 }}
                                                    />
                                                </FormControl>
                                            </GridItem>

                                        </GridContainer>

                                        <hr className="lineGray" />
                                    </>
                                }

                                <GridContainer>
                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="Glicose"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="glicose"
                                                inputRef={register({ required: true })}
                                                error={errors.glicose ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="Hemoglobina Glicada"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="hemoglobinaGlicada"
                                                inputRef={register({ required: true })}
                                                error={errors.hemoglobinaGlicada ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="Insulina"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="insulina"
                                                inputRef={register({ required: true })}
                                                error={errors.insulina ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="Peptídeo Calculo"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="peptideoCalculo"
                                                inputRef={register({ required: true })}
                                                error={errors.peptideoCalculo ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>

                                    {franquia != "Dr. Diabetes" &&
                                        <GridItem xs={12} sm={3} md={3}>
                                            <FormControl fullWidth className={classes.formControl}>
                                                <TextField
                                                    label="Perfil Lipídico"
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    defaultValue="0,00"
                                                    name="perfilLipidico"
                                                    inputRef={register({ required: true })}
                                                    error={errors.perfillipidico ? true : false}
                                                    InputProps={{
                                                        inputComponent: MaskDecimal
                                                    }}
                                                />
                                            </FormControl>
                                        </GridItem>
                                    }

                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="Ureia"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="ureia"
                                                inputRef={register({ required: true })}
                                                error={errors.ureia ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>

                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="Creatinina"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="creatinina"
                                                inputRef={register({ required: true })}
                                                error={errors.creatinina ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>

                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="TGO"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="tgo"
                                                inputRef={register({ required: true })}
                                                error={errors.tgo ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>

                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="TGP"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="tgp"
                                                inputRef={register({ required: true })}
                                                error={errors.tgp ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="Evolução de AMOx"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="evolucaoDeVO2"
                                                inputRef={register({ required: true })}
                                                error={errors.evolucaoDeVO2 ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimalComNegativo
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="Vitamina D"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="vitaminaD"
                                                inputRef={register({ required: true })}
                                                error={errors.vitaminaD ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>

                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="Triglicerídeos"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="triglicerideos"
                                                inputRef={register({ required: true })}
                                                error={errors.triglicerideos ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>

                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="G6PD"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="g6PD"
                                                inputRef={register({ required: true })}
                                                error={errors.g6PD ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="Massa Magra"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="massaMagra"
                                                inputRef={register({ required: true })}
                                                error={errors.massaMagra ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="HDL"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="hdl"
                                                inputRef={register({ required: true })}
                                                error={errors.hdl ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="LDL"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="ldl"
                                                inputRef={register({ required: true })}
                                                error={errors.ldl ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="Homa IR"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="homaIR"
                                                inputRef={register({ required: true })}
                                                error={errors.homaIR ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="Gordura Visceral"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="gorduraVisceral"
                                                inputRef={register({ required: true })}
                                                error={errors.gorduraVisceral ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label="RCQ"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue="0,00"
                                                name="vO2Absoluto"
                                                inputRef={register({ required: true })}
                                                error={errors.vO2Absoluto ? true : false}
                                                InputProps={{
                                                    inputComponent: MaskDecimal
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>

                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>

                <GridContainer>
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <Button onClick={() => handleViewForm()} color="#efefef" className={classes.updateProfileButton}>
                            {t('button.cancel')}
                        </Button>
                        <Button type="submit" color="primary" className={classes.updateProfileButton}>
                            {t('button.to_save')}
                            {loading && <div>{t('label.loading') + "..."}</div>}
                        </Button>
                    </GridItem>
                </GridContainer>
            </form>
        </>
    );
}